/** @jsxImportSource theme-ui */
import { Alert, Flex, Text } from 'theme-ui';
import { useSelector } from 'react-redux';
import localforage from 'localforage';
import Button from '@/components/Button';
import keycloak from '@/keycloak';
import { selectTokenRejected } from '@/store/auth';
import { AUTH_STORAGE_KEY } from '@/providers/AuthenticationProvider';

export const TOKEN_REJECTED_MESSAGE =
    'Your session could not be verified. Data cannot load until you sign in again.';

const TokenRejectedAlert: React.FC = () => {
    const isTokenRejected = useSelector(selectTokenRejected);
    if (!isTokenRejected) return null;

    return (
        <Alert variant="danger" bg="white" p={3} role="alert">
            <Flex
                sx={{
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    gap: 3,
                }}
            >
                <Text>{TOKEN_REJECTED_MESSAGE}</Text>
                <Flex sx={{ gap: 2 }}>
                    <Button variant="secondary" onClick={reloadPage}>
                        Reload
                    </Button>
                    <Button variant="danger" onClick={logOut}>
                        Log out
                    </Button>
                </Flex>
            </Flex>
        </Alert>
    );
};

const reloadPage = () => window.location.reload();

const logOut = () => localforage.removeItem(AUTH_STORAGE_KEY).finally(() => keycloak.logout());

export default TokenRejectedAlert;
